export default {
    LOAD_NOTICE_APP(state, notice) {
        state.items = notice;
    }
}